import { QueryModelCore } from "@/core/model.core";
import { getUUid } from "@/core/authUtil";
export default class Home {
  /**
   * 获取云闪付首页专题信息
   */
  async ysfIndexInfo() {
    const result = await new QueryModelCore('/api-cms/special/topic/app/getYSFTopic').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取H5商城首页数据
   */
  async indexResourceInfo() {
    const result = await new QueryModelCore('/api-cms/app/banners/listAll').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取H5商城资源列表
   * @param {Number} type 类型 1-轮播图 2-卡片信息 3-开屏广告 4-企服banner
   */
  async indexResourceList(type) {
    const result = await new QueryModelCore('/api-cms/app/banners/list').get({
      dicType: type,
      uuid: getUUid()
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取H5商城商家端首页数据
   */
  async retailResourceInfo(code) {
    const result = await new QueryModelCore('/api-cms/app/banners/listAll').get({
      subUuid: code
    });
    const { dataMap } = result;
    return dataMap;
  }
}